import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '../../../components/ui/Icons';
import styles from './Pager.module.css';

interface PagerProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

/** Devuelve la ventana de números de página a mostrar (máx 6). */
const getWindow = (page: number, total: number): number[] => {
  const maxButtons = 6;
  if (total <= maxButtons) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }
  let start = Math.max(1, page - 2);
  let end = start + maxButtons - 1;
  if (end > total) {
    end = total;
    start = end - maxButtons + 1;
  }
  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};

const Pager: React.FC<PagerProps> = ({ page, totalPages, onChange }) => {
  if (totalPages <= 1) return null;
  const pages = getWindow(page, totalPages);

  return (
    <div className={styles.pager}>
      <button
        type="button"
        className={styles.btn}
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        aria-label="Previous page"
      >
        <ChevronLeftIcon size={16} />
      </button>

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          className={[styles.btn, p === page ? styles.active : ''].filter(Boolean).join(' ')}
          onClick={() => onChange(p)}
        >
          {p}
        </button>
      ))}

      <button
        type="button"
        className={styles.btn}
        onClick={() => onChange(page + 1)}
        disabled={page >= totalPages}
        aria-label="Next page"
      >
        <ChevronRightIcon size={16} />
      </button>
    </div>
  );
};

export default Pager;
